import StandardGateway from '@ad-scripts/adapters/gateways/lib/standard_gateway';
import generateId from 'src/lib/generateId';

const HEADER_CORRELATION_ID = 'Gladly-Correlation-Id';
const VERSION = 'v1';

export default class TemporaryAuthTokensGateway extends StandardGateway {
  constructor(backend) {
    super(backend, VERSION);
  }

  facebookLoginTemporaryToken() {
    const correlationId = generateId();
    const url = this.endpoint.addUrl;
    return this.http
      .post(`${url}/users/facebook-login-tokens`, {}, { headers: { [HEADER_CORRELATION_ID]: correlationId } })
      .then(dto => {
        this.observer.onUpdateSuccess(dto, {});
        return dto;
      })
      .catch(error => {
        this.observer.onUpdateError(error, {});
        return dto;
      });
  }
}
